import React from 'react';

const VisionModal = ({ isOpen, onClose, language }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-3xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-blue-500 to-blue-600 text-white p-6 rounded-t-3xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <div>
                <h2 className="text-2xl font-bold">
                  {language === 'english' ? 'Our Vision' : 'हमारा विजन'}
                </h2>
                <p className="text-blue-100">
                  {language === 'english' ? 'Detailed Vision Information' : 'विस्तृत विजन जानकारी'}
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-200"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-8">
          {language === 'english' ? (
            <div className="space-y-6">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">Our Vision for the Future</h3>
                <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-600 mx-auto rounded-full"></div>
              </div>

              <div className="space-y-6">
                <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                    Leading Sports Organization
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    To become a leading sports organization that nurtures talent, promotes excellence, and contributes to the holistic development of youth and the strengthening of our community through sports.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                    Talent Development Hub
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    To establish ourselves as a premier talent development hub that identifies, nurtures, and guides young athletes towards achieving their full potential in cricket and other sports.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-purple-50 to-purple-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                    Community Excellence
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    To foster a culture of excellence within our community, where sports serve as a catalyst for personal growth, social cohesion, and positive change.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                    National Recognition
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    To gain recognition at the state and national levels for our contribution to sports development and youth empowerment in Chhattisgarh.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-red-50 to-red-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                    Sustainable Growth
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    To build a sustainable sports ecosystem that continues to grow and evolve, ensuring long-term benefits for future generations of athletes and community members.
                  </p>
                </div>
              </div>

              <div className="mt-8 p-6 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl text-white text-center">
                <h4 className="text-xl font-bold mb-2">Our Commitment</h4>
                <p className="text-blue-100">
                  We are committed to making this vision a reality through dedicated efforts, innovative programs, and unwavering support for our community's youth and sports development.
                </p>
              </div>
            </div>
          ) : (
            <div className="space-y-6">
              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">भविष्य के लिए हमारा विजन</h3>
                <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-600 mx-auto rounded-full"></div>
              </div>

              <div className="space-y-6">
                <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                    अग्रणी खेल संगठन
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    एक अग्रणी खेल संगठन बनना जो प्रतिभा का पोषण करे, उत्कृष्टता को बढ़ावा दे, और खेलों के माध्यम से युवाओं के समग्र विकास और समुदाय के सुदृढ़ीकरण में योगदान दे।
                  </p>
                </div>

                <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                    प्रतिभा विकास केंद्र
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    एक प्रमुख प्रतिभा विकास केंद्र के रूप में स्थापित होना जो युवा एथलीटों की पहचान करे, उनका पोषण करे और क्रिकेट तथा अन्य खेलों में उनकी पूर्ण क्षमता तक पहुंचने में मार्गदर्शन करे।
                  </p>
                </div>

                <div className="bg-gradient-to-r from-purple-50 to-purple-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                    सामुदायिक उत्कृष्टता
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    हमारे समुदाय के भीतर उत्कृष्टता की संस्कृति को बढ़ावा देना, जहां खेल व्यक्तिगत विकास, सामाजिक सामंजस्य और सकारात्मक परिवर्तन के लिए उत्प्रेरक का काम करें।
                  </p>
                </div>

                <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                    राष्ट्रीय पहचान
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    छत्तीसगढ़ में खेल विकास और युवा सशक्तिकरण में हमारे योगदान के लिए राज्य और राष्ट्रीय स्तर पर पहचान प्राप्त करना।
                  </p>
                </div>

                <div className="bg-gradient-to-r from-red-50 to-red-100 rounded-2xl p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                    सतत विकास
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    एक सतत खेल पारिस्थितिकी तंत्र का निर्माण करना जो निरंतर विकसित होता रहे, भविष्य की पीढ़ियों के एथलीटों और समुदायिक सदस्यों के लिए दीर्घकालिक लाभ सुनिश्चित करे।
                  </p>
                </div>
              </div>

              <div className="mt-8 p-6 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl text-white text-center">
                <h4 className="text-xl font-bold mb-2">हमारी प्रतिबद्धता</h4>
                <p className="text-blue-100">
                  हम समर्पित प्रयासों, नवाचारी कार्यक्रमों और हमारे समुदाय के युवाओं और खेल विकास के लिए अटूट समर्थन के माध्यम से इस विजन को साकार करने के लिए प्रतिबद्ध हैं।
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VisionModal;
